import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-column-chart',
    //templateUrl: './app/controls/components/chart/column-chart/column-chart.html'
    templateUrl: './column-chart.html',
})
export class ColumnChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/column-chart/column-chart-component.ts